var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4998 1.66675H2.49984C2.27882 1.66675 2.06686 1.75455 1.91058 1.91083C1.7543 2.06711 1.6665 2.27907 1.6665 2.50008V17.5001C1.6665 17.7211 1.7543 17.9331 1.91058 18.0893C2.06686 18.2456 2.27882 18.3334 2.49984 18.3334H17.4998C17.7209 18.3334 17.9328 18.2456 18.0891 18.0893C18.2454 17.9331 18.3332 17.7211 18.3332 17.5001V2.50008C18.3332 2.27907 18.2454 2.06711 18.0891 1.91083C17.9328 1.75455 17.7209 1.66675 17.4998 1.66675ZM11.6665 16.6667H3.33317V10.8334H11.6665V16.6667ZM11.6665 9.16675H3.33317V3.33341H11.6665V9.16675ZM16.6665 16.6667H13.3332V3.33341H16.6665V16.6667Z",
    fill: "#FAF6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2385b443fb817a27269e56ea836ceebb.svg";
export { ForwardRef as ReactComponent };